module.exports = __webpack_public_path__ + "img/content-with-img-links-honda.912be709.jpg";